/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ComponentItemFilterMode, ComponentItemFinderRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { DictionaryService, InitDialogViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { ComponentItemFinderListItem } from './component-item-finder-list-item.model';

export interface ComponentItemFinderDialogConfig extends FinderDialogConfig {
  filterMode?: ComponentItemFilterMode;
  disableFilterMode?: boolean;
  isNumericSelector?: boolean;
}

@Injectable()
export class ComponentItemFinderBusinessService implements InitDialogViewService<ComponentItemFinderDialogConfig> {
  constructor(private restService: ComponentItemFinderRestService,
              private dictionaryService: DictionaryService) {

  }

  initDialogView(): any {
    return {
      componentItemTypes: this.dictionaryService.getByEnum(ComponentItemFilterMode),
    };
  }

  findAllAsDataSource(type: ComponentItemFilterMode,
                      searchString?: string): SlicedDataSource<ComponentItemFinderListItem> {
    return this.restService.findAllAsDataSource({ searchType: type, searchString });
  }
}
